/* MASX · Reseñas talla real — muestra 4 opiniones y un botón "Ver más",
   igual que la ficha de SHEIN en el teléfono.
   Va aparte de la sección para poder ajustarlo sin resubir el archivo grande. */
(function () {
  var TOPE = 4;

  function montar(root) {
    var list = root.querySelector('[data-list]');
    if (!list || root.dataset.masxVermas === '1') return;
    root.dataset.masxVermas = '1';

    var abierto = false;
    var wrap = document.createElement('div');
    wrap.className = 'masx-rt__morewrap';
    wrap.hidden = true;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'masx-rt__more';
    wrap.appendChild(btn);
    list.parentNode.insertBefore(wrap, list.nextSibling);

    function aplicarTope() {
      var revs = list.querySelectorAll('.masx-rt__rev');
      var visibles = [];
      revs.forEach(function (r) {
        if (r.dataset.topeOculto === '1') { r.hidden = false; r.dataset.topeOculto = ''; }
      });
      revs.forEach(function (r) { if (!r.hidden) visibles.push(r); });

      var total = visibles.length;
      if (total <= TOPE) { wrap.hidden = true; return; }

      if (!abierto) {
        visibles.slice(TOPE).forEach(function (r) { r.hidden = true; r.dataset.topeOculto = '1'; });
        btn.textContent = 'Ver las ' + total + ' opiniones';
      } else {
        btn.textContent = 'Ver menos';
      }
      wrap.hidden = false;
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      abierto = !abierto;
      aplicarTope();
      if (!abierto) wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });

    // Cada vez que el cliente filtra, volvemos a las 4 primeras
    root.addEventListener('click', function (e) {
      if (e.target.closest('.masx-rt__tab, .masx-rt__chip, .masx-rt__sz')) {
        setTimeout(function () { abierto = false; aplicarTope(); }, 0);
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.closest('.masx-rt__filters')) {
        setTimeout(function () { abierto = false; aplicarTope(); }, 0);
      }
    });

    aplicarTope();
  }

  function arrancar() {
    document.querySelectorAll('.masx-rt').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  // el modo demostración inyecta las reseñas al vuelo: reintentamos una vez
  setTimeout(arrancar, 400);
})();
